<template>
  <div class="notification-name-field" :data-testid="dataTestid">
    <span class="notification-name-field__label">{{ label }}</span>
    <div
      class="notification-name-field__control"
      :class="{ 'notification-name-field__control--custom': isCustom }"
    >
      <v-text-field
        :value="displayValue"
        outlined
        dense
        hide-details="auto"
        :error-messages="error ? [error] : []"
        :placeholder="autoName"
        :data-testid="`${dataTestid}__input`"
        @input="onInput"
      />
      <v-btn
        v-if="isCustom"
        icon
        small
        class="notification-name-field__reset"
        title="Reset to auto name"
        @click="$emit('reset')"
      >
        <v-icon small>mdi-restore</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationNameField',
  props: {
    value: { type: String, default: '' },
    autoName: { type: String, default: '' },
    isCustom: { type: Boolean, default: false },
    error: { type: String, default: '' },
    dataTestid: { type: String, default: 'notification-name-field' },
    label: { type: String, default: 'Notification name' },
  },
  computed: {
    displayValue() {
      return this.isCustom ? this.value : this.autoName;
    },
  },
  methods: {
    onInput(next) {
      this.$emit('input', next);
      if (!this.isCustom) this.$emit('update:isCustom', true);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './NotificationNameField.scss';
</style>
